<mat-toolbar [ngClass]="{invisible: !visible(), visible: visible()}"
			 (mouseover)="toggle()"
			 (mouseout)="toggle()"
>
	<span>
		<span class="created-with-phrase">Created with<mat-icon color="primary">favorite</mat-icon>by</span>
		&copy;SCHEU-DENTAL {{currentYear}} [Version {{config.versionLabel}}]
	</span>
</mat-toolbar>
